export type EnvName = 'prod' | 'stg' | 'dev'

export interface EnvTheme {
  name: EnvName
  headerGradient: string
  subText: string
  pageGradient: string
  primaryHex: string
  primaryBtnClasses: string
  focusRing: string
  accentText: string
  bulletBg: string
  outlineBtnColors: string
  linkText: string
}

const detectEnv = (): EnvName => {
  const override = (import.meta.env.VITE_APP_ENV as string | undefined)?.toLowerCase()
  if (override === 'prod' || override === 'stg' || override === 'dev') return override
  const host = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : ''
  if (!host || host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local') || host.startsWith('192.168.')) {
    return 'dev'
  }
  if (host.includes('stg') || host.includes('staging')) return 'stg'
  return 'prod'
}

const themes: Record<EnvName, EnvTheme> = {
  prod: {
    name: 'prod',
    headerGradient: 'from-blue-700 to-blue-600',
    subText: 'text-blue-100',
    pageGradient: 'from-slate-100 to-blue-50',
    primaryHex: '#2563eb',
    primaryBtnClasses: 'bg-blue-600 text-white hover:bg-blue-700',
    focusRing: 'focus:ring-blue-500',
    accentText: 'text-blue-600',
    bulletBg: 'bg-blue-500',
    outlineBtnColors: 'border-blue-400 text-blue-700 hover:bg-blue-50',
    linkText: 'text-blue-700',
  },
  stg: {
    name: 'stg',
    headerGradient: 'from-amber-600 to-yellow-500',
    subText: 'text-amber-50',
    pageGradient: 'from-slate-100 to-amber-50',
    primaryHex: '#d97706',
    primaryBtnClasses: 'bg-amber-600 text-white hover:bg-amber-700',
    focusRing: 'focus:ring-amber-500',
    accentText: 'text-amber-600',
    bulletBg: 'bg-amber-500',
    outlineBtnColors: 'border-amber-400 text-amber-700 hover:bg-amber-50',
    linkText: 'text-amber-700',
  },
  dev: {
    name: 'dev',
    headerGradient: 'from-rose-700 to-red-600',
    subText: 'text-rose-100',
    pageGradient: 'from-slate-100 to-rose-50',
    primaryHex: '#e11d48',
    primaryBtnClasses: 'bg-rose-600 text-white hover:bg-rose-700',
    focusRing: 'focus:ring-rose-500',
    accentText: 'text-rose-600',
    bulletBg: 'bg-rose-500',
    outlineBtnColors: 'border-rose-400 text-rose-700 hover:bg-rose-50',
    linkText: 'text-rose-700',
  },
}

let cached: EnvTheme | null = null

export const getEnvTheme = (): EnvTheme => {
  if (!cached) cached = themes[detectEnv()]
  return cached
}
